import { render, staticRenderFns } from "./ProjectHighlightItem.vue?vue&type=template&id=646512dc&scoped=true&"
import script from "./ProjectHighlightItem.vue?vue&type=script&lang=js&"
export * from "./ProjectHighlightItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectHighlightItem.vue?vue&type=style&index=0&id=646512dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646512dc",
  null
  
)

export default component.exports